<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">A BEAST <br/>IN PARADISE</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a-beast-in-paradise_00000.vue?8df3bf68